var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-card",
        { staticClass: "home-form-container", attrs: { color: "#f0f0ef" } },
        [
          _vm.editedItem !== null
            ? _c(
                "v-card-text",
                {
                  staticClass: "home-form-container",
                  staticStyle: {
                    "text-align": "left",
                    padding: "4px 0 0 0",
                    overflow: "visible"
                  }
                },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        label:
                          _vm.familyId === "ac"
                            ? _vm.$tc("Accessory", 1)
                            : _vm.$tc("Other", 1),
                        value: _vm.editedItem.sm_quantity,
                        "input-type": "other",
                        size: "100",
                        required: true,
                        "field-disabled": _vm.editing
                      }
                    },
                    [
                      _c("treeselect", {
                        attrs: {
                          value: _vm.editedItem.sm_id,
                          options: _vm.accessoriesOptions,
                          "load-options": _vm.loadAccessoriesOptions,
                          normalizer: _vm.accessoriesOptionsNormalizer,
                          searchable: false,
                          disabled: _vm.editing
                        },
                        on: { input: _vm.updateValue }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("input-field", {
                    attrs: {
                      label: _vm.$t("Quantity"),
                      "input-type": "number",
                      min: 0,
                      size: "100",
                      required: true
                    },
                    model: {
                      value: _vm.editedItem.quantity,
                      callback: function($$v) {
                        _vm.$set(_vm.editedItem, "quantity", $$v)
                      },
                      expression: "editedItem.quantity"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c("management-button", {
                attrs: { type: "cancel", label: _vm.$t("Cancel") },
                on: { buttonClick: _vm.close }
              }),
              _vm._v(" "),
              _c("management-button", {
                attrs: {
                  type: "execute",
                  label: _vm.editing ? _vm.$t("ApplyChanges") : _vm.$t("Add"),
                  disabled: !_vm.requiredAreFilled
                },
                on: { buttonClick: _vm.applyChanges }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f6915ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6915ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersForm.vue
// module id = null
// module chunks = 